export default "__VITE_ASSET___8eNqn6QUYmeKWLG9tKB8A__"